export const bloc0Constants = {
  GET_BLOC0_REQUEST: 'GET_BLOC0_REQUEST',
  GET_BLOC0_SUCCESS: 'GET_BLOC0_SUCCESS',
  GET_BLOC0_FAILURE: 'GET_BLOC0_FAILURE',

  UPDATE_BLOC0_REQUEST: 'UPDATE_BLOC0_REQUEST',
  UPDATE_BLOC0_SUCCESS: 'UPDATE_BLOC0_SUCCESS',
  UPDATE_BLOC0_FAILURE: 'UPDATE_BLOC0_FAILURE',
};
